(() => {
  const onLoad = (fn) => window.addEventListener("load", fn, { once: true });

  onLoad(() => {
    try {
      const findRealButton = () => {
        const byId = document.getElementById("addToCartButton");
        if (byId) return byId;

        const form = document.querySelector('form[action*="/cart/add"], form[data-product-form]');
        if (!form) return null;

        return form.querySelector('button[type="submit"]');
      };

      const realBtn = findRealButton();
      if (!realBtn) return;

      // crea barra sticky
      const bar = document.createElement("div");
      bar.className = "sticky-atc";
      bar.setAttribute("data-sticky-atc", "1");

      const btn = document.createElement("button");
      btn.type = "button";
      btn.textContent = "AÑADIR A MI CARRITO";
      bar.appendChild(btn);

      document.body.appendChild(bar);

      const sync = () => {
        // mòbil
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        bar.style.display = isMobile ? "block" : "none";

        // preu (opcional)
        const priceEl = document.querySelector(".product-price-block [data-product-price]");
        const priceTxt = priceEl ? priceEl.textContent.trim() : "";
        btn.textContent = priceTxt ? `AÑADIR A MI CARRITO · ${priceTxt}` : "AÑADIR A MI CARRITO";

        btn.disabled = realBtn.disabled || realBtn.getAttribute("disabled") !== null;
      };

      btn.addEventListener("click", () => realBtn.click());
      window.addEventListener("resize", sync);
      sync();
    } catch (e) {
      console.error("Sticky ATC failed:", e);
    }
  });
})();
